import React, { useState, useEffect } from 'react'
import { Button, Row, Col, Form, Card } from 'react-bootstrap'
import ModalContainer from './ModalContainer'
import Message from '../../shared_components/Message'

export const JitaiGroupAssignmentSetting = ({ 
  group, 
  index, 
  jitai_decision_rules,
  next_stage_participant_groups,
  handleDelete 
}) => {
  const [show, setShow] = useState(false)

  const [nextStageGroupAssignmentRule, setNextStageGroupAssignmentRule] = useState(null)
  const [assignedGroup, setAssignedGroup] = useState(null)

  const [saveError, setSaveError] = useState('')

  useEffect(() => {
    const setting = group.next_stage_group_assignment_settings[index]
    setNextStageGroupAssignmentRule(setting.next_stage_group_assignment_rule || null)
    setAssignedGroup(setting.assigned_group || null)
  }, [group, index])

  const handleOpen = () => {
    setShow(true)
  }

  const checkSettings = () => {
    if (!nextStageGroupAssignmentRule) {
      return 'Decision Rule must be selected'
    }
    if (!assignedGroup) {
      return 'Assigned Group must be selected'
    }
    return ''
  }

  const handleClose = () => {
    setSaveError('')
    let error = ''

    if (error.length === 0) error = checkSettings()

    if (error.length === 0) {
      group.next_stage_group_assignment_settings[index].next_stage_group_assignment_rule = nextStageGroupAssignmentRule
      group.next_stage_group_assignment_settings[index].assigned_group = assignedGroup
      setShow(false)
    } else {
      setSaveError(error)
    }
  }

  const getDecisionRuleCode = () => {
    if (!nextStageGroupAssignmentRule) return 'Not Set'
    const rule = jitai_decision_rules?.find(r => r._id === nextStageGroupAssignmentRule)
    return rule ? rule.code : 'Unknown Rule'
  }

  const getAssignedGroupName = () => {
    if (!assignedGroup) return 'Not Set'
    const grp = next_stage_participant_groups?.find(g => g._id === assignedGroup)
    return grp ? `${grp.name} (Group ${grp.group_num})` : 'Unknown Group'
  }

  return (
    <>
      <Card className='p-2 my-2 rounded'>
        <Row style={{ marginLeft: '-5px', marginBottom: '15px' }}>
          <Col md={12} style={{ whiteSpace: 'normal' }}>
            <div><strong>Rule:</strong> {getDecisionRuleCode()}</div>
            <div><strong>Assign to:</strong> {getAssignedGroupName()}</div>
          </Col>
        </Row>
        <Row style={{ marginLeft: '-5px' }}>
          <Col md={6}></Col>
          <Col md={3}>
            <Button
              style={{ width: '100%' }}
              variant='primary'
              className='btn-sm'
              onClick={handleOpen}
            >
              Edit
            </Button>
          </Col>
          <Col md={3}>
            <Button
              style={{ width: '100%', marginLeft: '-12px' }}
              variant='danger'
              className='btn-sm'
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Col>
        </Row>
      </Card>

      <ModalContainer
        title='Edit Group Assignment Setting'
        show={show}
        handleClose={handleClose}
      >
        {saveError && <Message variant='danger'>{saveError}</Message>}
        
        {/* Decision Rule Section */}
        <Row>
          <Col md={12}>
            <Form.Group controlId={'group_assignment_rule' + group._id + index}>
              <Form.Label>
                Group Assignment Decision Rule <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              {jitai_decision_rules && jitai_decision_rules.filter(rule => rule.type === 'groupAssignment').length === 0 ? (
                <div style={{ padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                  <p style={{ margin: 0, color: '#6c757d', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    No Group Assignment decision rules available. Please create one first.
                  </p>
                </div>
              ) : (
                <Form.Control
                  as='select'
                  value={nextStageGroupAssignmentRule || ''}
                  onChange={(e) => {
                    setNextStageGroupAssignmentRule(e.target.value || null)
                  }}
                >
                  <option value=''>—Select Decision Rule—</option>
                  {jitai_decision_rules && jitai_decision_rules
                    .filter(rule => rule.type === 'groupAssignment')
                    .map((rule) => (
                      <option key={rule._id} value={rule._id}>
                        {rule.code}
                      </option>
                    ))}
                </Form.Control>
              )}
            </Form.Group>
          </Col>
        </Row>

        {/* Assigned Group Section */}
        <Row style={{ marginTop: '15px' }}>
          <Col md={12}>
            <Form.Group controlId={'assigned_group' + group._id + index}>
              <Form.Label>
                Assigned Participant Group <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              {next_stage_participant_groups && next_stage_participant_groups.length === 0 ? (
                <div style={{ padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                  <p style={{ margin: 0, color: '#6c757d', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    No participant groups available in the next stage. Please add groups to the next stage first.
                  </p>
                </div>
              ) : (
                <Form.Control
                  as='select'
                  value={assignedGroup || ''}
                  onChange={(e) => {
                    setAssignedGroup(e.target.value || null)
                  }}
                >
                  <option value=''>—Select Participant Group—</option>
                  {next_stage_participant_groups && next_stage_participant_groups.map((grp) => (
                    <option key={grp._id} value={grp._id}>
                      {grp.name} (Group {grp.group_num})
                    </option>
                  ))}
                </Form.Control>
              )}
            </Form.Group>
          </Col>
        </Row>
      </ModalContainer>
    </>
  )
}

export default JitaiGroupAssignmentSetting
